import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router';

function Seo({
  description,
  lang = `en`,
  meta = [],
  title,
  structuredData = {},
  metaImage = null,
  canonicalURL = null,
  noindex = false,
}) {
  const location = useLocation();
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;

  const metaUrl = canonicalURL || `${site.siteMetadata.siteUrl}${location.pathname}`;

  const metaImageLogo = {
    url: metaImage || `${site.siteMetadata.siteUrl}/og-image.png`,
    width: 1200,
    height: 630,
  };

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: metaUrl,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: metaImageLogo.url,
        },
        {
          property: 'og:image:width',
          content: metaImageLogo.width,
        },
        {
          property: 'og:image:height',
          content: metaImageLogo.height,
        },
      ].concat(meta)}
    >
      <title>{title}</title>

      <script>
        {/* Microsoft Ads tracking script */}
        {`(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"26336290"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`}
      </script>

      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      {!!canonicalURL && <link rel="canonical" href={canonicalURL} />}
      {!!noindex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
};

export default Seo;
